let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f8WJw")).then(() => parcelRequire('67K5D'));